import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	text: {
		id: 'servicedesk-knowledge-common.create-article-button.text',
		defaultMessage: 'Create article',
		description: 'Button text to be displayed when user wants to create an article in JSM',
	},
});
